export enum EducationLevelEnum {
    KINDERGARTEN = 'kindergarten',
    PRIMARY = 'primary',
}
